import { render, staticRenderFns } from "./layout-guide.vue?vue&type=template&id=7da329a2&"
import script from "./layout-guide.vue?vue&type=script&lang=js&"
export * from "./layout-guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports